import { POST_QUERY_REQUEST, POST_QUERY_SUCCESS, POST_QUERY_ERROR } from "../../types/types";
export default function ormeAgent(state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case POST_QUERY_REQUEST:
			return {
				loading: true,
			};
		case POST_QUERY_SUCCESS:
			return {
				...state,
				loading: false,
				payload: payload,
			};
		case POST_QUERY_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		default:
			return state;
	}
}